import Component from "vue-class-component";
import moduleStore from "./store/addWorkPage";
import Vue from "vue";
import PageState from "./store/state";
import activityMixin from '@/mixins/activity-mixin'
/**components**/
@Component({
  mixins: [activityMixin]
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class addWorkPagePage
  extends Vue
  implements IvuePage<PageState>
{
  state = new PageState();
  self: Vue = this;
  // 用户信息
  userInfo = {
    id:"",
    avatar: "",
    nickName: "",
    updatedAt: "",
    status: "",
  };
  activityId = null;
  bindAccountId = null;
  workTemp = {
    videoUrl: "",
  };
  // 作品列表
  // workList: Array<any> = [{ id:1,activityId:1,bindAccountId:1,videoUrl: "",videoIndex:1 }];
  workList: Array<any> = [];
  isCommiting = false; //是否正在提交中
  platformMap={'dou_yin':'抖音','kuai_shou':'快手'};
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  mounted(moduleData: IinjectDatas) {
    document.title = "添加作品链接";
    this.state.self = this;
    let account:any = this.$route.query.accountInfo as string;
    if(account){
      this.userInfo = JSON.parse(account);
      console.log('---userInfo---',this.userInfo);
      this.bindAccountId = this.userInfo.id;
    }
    this.activityId = this.$route.query.activityId;
    // console.log(this.$route.query);
   
    if(this.bindAccountId){
      console.log('准备获取----列表',this.bindAccountId);
      this.getWorkListFn();
    }
  }
  // 返回上一页
  goBack() {
    this.$router.back();
  }
  // 新增作品
  addNewWork() {
    const newWorkInfo = { ...this.workTemp };
    this.workList.push(newWorkInfo);
  }
  // 删除作品
  deleteWork(index: number) {
    this.workList.splice(index, 1);
  }

  // 确认提交
  confirmWorks() {
    if (this.isCommiting) return;
    this.isCommiting = true;
    console.log("提交作品列表:", this.workList);
    //检查作品项链接必填
    const emptyUrlWorks = this.workList.filter((work) => !work.videoUrl);
    if (emptyUrlWorks.length > 0) {
      this.$toast("请填写所有作品视频链接");
      this.isCommiting = false;
      return;
    }
    this.workList = this.workList.map((work, index) => ({
      ...work,
      bindAccountId: this.bindAccountId,
      activityId: this.activityId,
      videoIndex: index,
    }));

    console.log("提交作品列表:", this.workList);
    this.$http("manageVideoInfo", this.workList ).then((res) => {
      this.isCommiting = false;
      let {code,message}=res;
      if (res.code === 200) {
        this.$router.back();
      }else{
        this.$toast(message);
      }
    });
  }
  // 获取作品列表
  getWorkListFn() {
    console.log("获取作品列表",this.bindAccountId);
    this.$http("getWorkList", { bindAccountId: this.bindAccountId }).then(
      (res) => {
        if (res.code === 200) {
          res.data = res.data.length==0?[{ videoUrl: "",}]:res.data;
          this.workList = res.data;
        }
      }
    );
  }
}
